export default {
  nearestVertexIndex(vertexPixels, pixel, tolerance) {
    let nearestIndex = -1
    let nearestDistance = tolerance

    vertexPixels.forEach(([x, y], index) => {
      const distance = Math.hypot(x - pixel[0], y - pixel[1])
      if (distance <= nearestDistance) {
        nearestIndex = index
        nearestDistance = distance
      }
    })

    return nearestIndex
  },

  coordinatesWithoutVertex(geometryType, coordinates, vertexIndex) {
    if (geometryType === 'LineString') {
      if (coordinates.length <= 2) return null

      return coordinates.filter((_, index) => index !== vertexIndex)
    }

    const [outerRing, ...holes] = coordinates
    const ringVertices = outerRing.slice(0, -1)
    if (ringVertices.length <= 3) return null

    const remainingVertices = ringVertices.filter((_, index) => index !== vertexIndex)
    return [[...remainingVertices, remainingVertices[0]], ...holes]
  }
}
